import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './bootstrap-custom.scss'
import 'bootstrap'
// import bootstrap from 'bootstrap/dist/js/bootstrap.bundle.js'
// window.bootstrap = bootstrap

store.dispatch('initialiseApp')

createApp(App).use(store).use(router).mount('#app')
